import { render, staticRenderFns } from "./PriceBox.vue?vue&type=template&id=6cbd2d40&scoped=true&"
import script from "./PriceBox.vue?vue&type=script&lang=ts&"
export * from "./PriceBox.vue?vue&type=script&lang=ts&"
import style0 from "./PriceBox.vue?vue&type=style&index=0&id=6cbd2d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbd2d40",
  null
  
)

export default component.exports